/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 心電図波形
 */
export type TreatmentROSCECGWaveFormEnum =
  (typeof TreatmentROSCECGWaveFormEnum)[keyof typeof TreatmentROSCECGWaveFormEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentROSCECGWaveFormEnum = {
  VF: 'VF',
  VT: 'VT',
  PEA: 'PEA',
  ASYSTOLE: 'ASYSTOLE',
  SINUS: 'SINUS',
  ARRHYTHMIA: 'ARRHYTHMIA',
  OTHER: 'OTHER',
} as const;
